"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/divider/style/index.js
// module id = 75
// module chunks = 1